import { withStyles } from 'tss-react/mui';
import { ClassNameMap } from '@mui/material';
import {
  ACCEPTABLE_IMAGE_FORMATS,
} from '@uplift/constants';
import { ChangeEventHandler } from 'react';


export type ImageInputProps = {
  onChange: ChangeEventHandler<HTMLInputElement>;
  classes?: ClassNameMap<'imageInput'>;
  id: string;
};


export const ImageInputRaw: React.FC<ImageInputProps> = ({ onChange, classes, id }) => (
  <input
    accept={ACCEPTABLE_IMAGE_FORMATS}
    className={classes?.imageInput}
    onChange={onChange}
    id={id}
    type="file"
  />
);


export const ImageInput = withStyles(ImageInputRaw, {
  imageInput: {
    width: '250px',
    height: '250px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'none',
  },
});
